<template>
  <md-layout mdAlign="center">
    <div class="half">
      <md-card>
        <md-card-header>
          <md-whiteframe md-tag="md-toolbar" md-elevation="2" class="md-medium">
            <div class="md-toolbar-container"></div>
            <div class="md-toolbar-container">
              <h2 class="md-title">Login</h2>
            </div>
          </md-whiteframe>
        </md-card-header>

        <md-card-content class="scrolable">
          <form>
            <md-input-container :class="{ 'md-input-invalid' : user.hasError}">
              <label>Login</label>
              <md-input v-model="user.username" @input="removeError()"></md-input>
              <span class="md-error">{{snack.message}}</span>
            </md-input-container>

            <md-input-container md-has-password :class="{ 'md-input-invalid' : user.hasError}">
              <label>Senha</label>
              <md-input v-model="user.password" type="password" @input="removeError()"></md-input>
            </md-input-container>

            <md-button @click="login" class="md-primary md-raised full">
              Entrar
              <md-spinner v-if="isRequesting === true" class="md-accent" :md-size="20" md-indeterminate></md-spinner>
            </md-button>
          </form>
        </md-card-content>
      </md-card>
      <md-snackbar :md-position="snack.vertical + ' ' + snack.horizontal" ref="snackbar" :md-duration="snack.duration">
        <span>{{snack.message}}</span>
        <md-button class="md-accent" @click="$refs.snackbar.close()">Ok</md-button>
      </md-snackbar>
    </div>
  </md-layout>
</template>

<script>
  import ticketsService from "../services/TicketsService";
  import AuthService from "../services/AuthService";
  import router from "../router/index";
  import LocalMessageService from "../services/LocalMessageService";
  import loginInfoService from '../services/LoginInfoService'

  export default {

    data(){
      return {
        user: {
          username: null,
          password: null,
          hasError: false
        },

        snack: {
          vertical: 'bottom',
          horizontal: 'center',
          duration: 6000,
          message: null
        },
        isRequesting: false
      }
    },

    created(){
      this.snack.message = LocalMessageService.getLocalMessage();
    },

    mounted(){
      if(LocalMessageService.getLocalMessage()){
        setTimeout(() => {
          this.openSnackMessage();
          LocalMessageService.removeLocalMessage();
        }, 1000);
      }
    },

    methods: {
      login : function () {
        this.isRequesting = true;
        ticketsService.login(this.user).then((success) => {
          this.isRequesting = true;
          var loginInfo = success.body;
          loginInfoService.setLoginInfo(loginInfo)
          AuthService.createToken(this.user);
          
          router.push({path: '/'});
        }, (error) => {
          this.isRequesting = false;
          if(error.status === 401){
            this.user.hasError = true;
            this.snack.message = error.bodyText;
            this.openSnackMessage();
          }
        });
      },

      removeError :function () {
        if(this.user.hasError === true){
          this.user.hasError = false;
        }
      },

      openSnackMessage : function() {
        this.$refs.snackbar.open();
      }
    }

  }
</script>

<style>
  .half{
    width: 50%;
  }

  .full{
    margin-left: 0px !important;
    margin-right: 0px !important;
  }

  .align-to-field{
    margin-top: 15px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue